import React, { Suspense, useReducer } from "react";
// import Redirecting from "./containers/Redirecting";
// import DeviceList from "./containers/DeviceList";
import DeviceDetail from "./containers/DeviceDetail";
import DeviceControl from "./containers/DeviceControl";
import DeployFile from "./containers/DeployFile";
import BIOSUpdate from "./containers/BIOSUpdate";
import FWUpdate from "./containers/FWUpdate";
import KioskMode from "./containers/KioskMode";
import OraUpdate from "./containers/OraUpdate";
import Screenshot from "./containers/Screenshot";
import IOSetUp from "./containers/IOSetUp";
import Rotation from "./containers/Rotation";
import Dashboard from "./containers/Dashboard";
import RestartSystem from "./containers/RestartSystem";
import VerifyEmail from "./containers/VerifyEmail";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import PrivateRoute from "./hoc/PrivateRoute";
import Auth from "./auths/Auth";
import PowerManagement from "./containers/PowerManagement";
import AdminUtility from "./containers/AdminUtility";
import AlarmNotification from "./containers/AlarmNotification";
import NoPermission from "./containers/NoPermission";
import {
  styledSubmitBtnState,
  styledSubmitBtnReducer
} from "./reducers/styledSubmitBtnReducer";
import FileBrowser from "./containers/FileBrowser";
import SharedWithMe from "./containers/SharedWithMe";
import File from "./containers/File";
import VNCSetting from "./containers/VNCSetting";
import GroupsDevices from "./containers/GroupsDevices";
// import GroupsUsers from "./containers/GroupsUsers";
import DeviceControlLog from "./containers/DeviceControlLog";
import DeviceLog from "./containers/DeviceLog";
import AlarmTemplates from "./containers/Alarm/Template";
import AlarmDevices from "./containers/Alarm/Devices";
import AlarmHistory from "./containers/Alarm/History";
import CreateAlarmTemplate from "./containers/Alarm/CreateTemplate";
import CreateScheduleTemplate from "./containers/Schedule/CreateTemplate";
import ScheduleTemplates from "./containers/Schedule/Templates";
import ScheduleList from "./containers/Schedule/List";
import ScheduleHistory from "./containers/Schedule/History";
import ScheduleCalendar from "./containers/Schedule/Calendar";
import AppUpdateService from "./containers/AppUpdateService";
import Tags from "./containers/Tags";
import CASLogin from "./containers/CASLogin";
import LoginError from "./containers/LoginError";
import GlobalProvider from "./GlobalProvider";
import AndroidApp from "@/containers/AndroidApp";
import WindowsApp from "@/containers/WindowsApp";
import ProfileTemplateList from "@/containers/ProfileConfig/Template";
import ProfileCreateAndroidTemplate from "@/containers/ProfileConfig/CreateTemplate/CreateAndroidTemplate";
import ProfileCreateWindowsTemplate from "@/containers/ProfileConfig/CreateTemplate/CreateWindowsTemplate";
import CompanySetting from "./containers/Setting/Company";
import DeviceNaming from "./containers/Setting/DeviceNaming";
import CreateNaming from "./containers/Setting/CreateNaming";
import Announcement from "./containers/Announcement";
import AnnouncementContent from "./containers/Announcement/AnnouncementContent";
import InstallHistory from "@/containers/ProfileConfig/History";
import CMSTemplateList from "@/containers/CMS/TemplateList";
import CMSResourceList from "@/containers/CMS/ResourceList";
import CMSHistory from "@/containers/CMS/History";
import CMSFullScreenTemplate from "./containers/CMS/TemplateList/CMSFullScreenTemplate";
import CMSPLDMTemplate from "./containers/CMS/TemplateList/CMSPLDMTemplate";
import { LanguageProvider } from "./langs/LanguageProvider";

// import * as localforage from "localforage";
// import axios from "axios";
// import { url } from "../src/apis/apiSetup";

// use for recognize the node server and kill it, rather than kill all the node server.
try {
  process.title = "Nubis";
} catch (e) { }

export const SubmitBtnContext = React.createContext({}); // context for btn loading animation
function App() {
  // eslint-disable-next-line no-unused-vars
  const [state, dispatch] = useReducer(
    styledSubmitBtnReducer,
    styledSubmitBtnState
  );

  return (
    <Suspense fallback="loading">
      <Auth>
        <GlobalProvider>
          <LanguageProvider>
            {/* Auth get the value sent from the AuthContext.Provider */}
            <SubmitBtnContext.Provider
              value={{
                loading: styledSubmitBtnState.loading,
                success: styledSubmitBtnState.success,
                dispatch
              }}
            >
              <BrowserRouter>
                <Switch>
                  <PrivateRoute
                    permissionName="multiple_vnc_setting"
                    path="/multiple-devices-task/vnc-setting"
                    component={VNCSetting}
                  />
                  <PrivateRoute
                    permissionName={["Nubis Drive", "share_with_me_view"]}
                    path="/nubis-drive/shared-with-me/:id/:name"
                    component={SharedWithMe}
                  />
                  <PrivateRoute
                    permissionName={["Nubis Drive", "share_with_me_view"]}
                    path="/nubis-drive/shared-with-me"
                    component={SharedWithMe}
                  />
                  <PrivateRoute
                    permissionName={[
                      "Nubis Drive",
                      "android_app_management_view"
                    ]}
                    path="/nubis-drive/android-app"
                    component={AndroidApp}
                  />
                  <PrivateRoute
                    permissionName={[
                      "Nubis Drive",
                      "android_app_management_view"
                    ]}
                    path="/nubis-drive/windows-app"
                    component={WindowsApp}
                  />
                  <PrivateRoute
                    permissionName={["Nubis Drive", "file_management_view"]}
                    path="/nubis-drive/file"
                    component={File}
                  />
                  <PrivateRoute
                    permissionName={["Nubis Drive", "file_brower_view"]}
                    path="/nubis-drive/file-browser/:id/:name"
                    component={FileBrowser}
                  />
                  <PrivateRoute
                    permissionName={["Nubis Drive", "file_brower_view"]}
                    path="/nubis-drive/file-browser"
                    component={FileBrowser}
                  />
                  <PrivateRoute
                    permissionName="alarm_notification_page"
                    path="/alarm-notification"
                    component={AlarmNotification}
                  />
                  <PrivateRoute
                    permissionName=""
                    path="/device-control"
                    component={DeviceControl}
                  />
                  <PrivateRoute
                    permissionName="Device Monitoring"
                    path="/groups/groups-devices"
                    component={GroupsDevices}
                  />
                  <PrivateRoute
                    permissionName="device_tag_mapping"
                    path="/groups/tags"
                    component={Tags}
                  />
                  {/* <PrivateRoute
                        permissionName="account_group_mapping"
                        path="/groups/users"
                        component={GroupsUsers}
                      /> */}
                  <PrivateRoute
                    permissionName=""
                    path="/groups/device-control-log"
                    component={DeviceControlLog}
                  />
                  <PrivateRoute
                    permissionName=""
                    path="/groups/device-log"
                    component={DeviceLog}
                  />
                  <PrivateRoute
                    permissionName="Alarm Management"
                    path="/alarm/templates"
                    component={AlarmTemplates}
                  />
                  <PrivateRoute
                    permissionName="alarm_policy_create"
                    path="/alarm/template/create"
                    component={CreateAlarmTemplate}
                  />
                  <PrivateRoute
                    permissionName="alarm_policy_edit"
                    path="/alarm/template/edit/:id"
                    component={CreateAlarmTemplate}
                  />
                  <PrivateRoute
                    permissionName="alarm_policy_edit"
                    path="/alarm/template/info/:id"
                    component={CreateAlarmTemplate}
                  />
                  <PrivateRoute
                    permissionName="Alarm Management"
                    path="/alarm/device-list"
                    component={AlarmDevices}
                  />
                  <PrivateRoute
                    permissionName="Alarm Management"
                    path="/alarm/history"
                    component={AlarmHistory}
                  />
                  <PrivateRoute
                    permissionName="Schedule Task Management"
                    path="/schedule/templates"
                    component={ScheduleTemplates}
                  />
                  <PrivateRoute
                    permissionName="Schedule Task Management"
                    path="/schedule/list"
                    component={ScheduleList}
                  />
                  <PrivateRoute
                    permissionName="Schedule Task Management"
                    path="/schedule/history"
                    component={ScheduleHistory}
                  />
                  <PrivateRoute
                    permissionName="Schedule Task Management"
                    path="/schedule/calendar/:deviceSerialNumber?"
                    component={ScheduleCalendar}
                  />
                  <PrivateRoute
                    permissionName="schedule_task_policy_create"
                    path="/schedule/template/create"
                    component={CreateScheduleTemplate}
                  />
                  <PrivateRoute
                    permissionName="schedule_task_policy_edit"
                    path="/schedule/template/edit/:id"
                    component={CreateScheduleTemplate}
                  />
                  <PrivateRoute
                    permissionName="schedule_task_policy_edit"
                    path="/schedule/template/info/:id"
                    component={CreateScheduleTemplate}
                  />
                  <PrivateRoute
                    // permissionName=""
                    path="/CMS/template/list"
                    component={CMSTemplateList}
                  />
                  <PrivateRoute
                    // permissionName=""
                    path="/CMS/resource/list"
                    component={CMSResourceList}
                  />
                  <PrivateRoute
                    // permissionName=""
                    path="/CMS/history"
                    component={CMSHistory}
                  />
                  <PrivateRoute
                    // permissionName="power_management_page"
                    path="/power-management"
                    component={PowerManagement}
                  />
                  <PrivateRoute
                    permissionName="app_update_service_page"
                    path="/app-update-service"
                    component={AppUpdateService}
                  />
                  <PrivateRoute
                    permissionName="No Permission"
                    path="/no-permission"
                    component={NoPermission}
                  />
                  <PrivateRoute
                    permissionName="file_brower_view"
                    path="/nubis-drive/admin-utility"
                    component={AdminUtility}
                  />
                  <PrivateRoute
                    permissionName="Device Monitoring Detail"
                    path="/device-list/device-detail/:device_id/:device_os_type"
                    component={DeviceDetail}
                  />
                  <PrivateRoute
                    permissionName="multiple_deploy_file"
                    path="/multiple-devices-task/deploy-file"
                    component={DeployFile}
                  />
                  <PrivateRoute
                    permissionName="single_deploy_file"
                    path="/deploy-file/:device_id/:device_os_type"
                    component={DeployFile}
                  />
                  <PrivateRoute
                    permissionName="multiple_restart_system"
                    path="/multiple-devices-task/restart-system"
                    component={RestartSystem}
                  />
                  <PrivateRoute
                    permissionName="single_restart_system"
                    path="/restart-system/:device_id/:device_os_type"
                    component={RestartSystem}
                  />
                  <PrivateRoute
                    permissionName="multiple_bios_update"
                    path="/multiple-devices-task/bios-update"
                    component={BIOSUpdate}
                  />
                  <PrivateRoute
                    permissionName="single_bios_update"
                    path="/bios-update/:device_id/:device_os_type"
                    component={BIOSUpdate}
                  />
                  <PrivateRoute
                    permissionName="multiple_peripherals_fw_update"
                    path="/multiple-devices-task/fw-update"
                    component={FWUpdate}
                  />
                  <PrivateRoute
                    permissionName="multiple_kiosk_mode"
                    path="/multiple-devices-task/kiosk-mode"
                    component={KioskMode}
                  />
                  <PrivateRoute
                    permissionName="device_detail_kiosk"
                    path="/kiosk-mode/:device_id/:device_os_type"
                    component={KioskMode}
                  />
                  <PrivateRoute
                    permissionName="multiple_update_ora"
                    path="/multiple-devices-task/ora-update"
                    component={OraUpdate}
                  />
                  <PrivateRoute
                    permissionName="single_update_ora"
                    path="/ora-update/:device_id/:device_os_type"
                    component={OraUpdate}
                  />
                  <PrivateRoute
                    permissionName="multiple_screenshot"
                    path="/multiple-devices-task/screenshot"
                    component={Screenshot}
                  />
                  <PrivateRoute
                    permissionName="device_detail_screenshot"
                    path="/screenshot/:device_id/:device_os_type"
                    component={Screenshot}
                  />
                  <PrivateRoute
                    permissionName="multiple_io_set_up"
                    path="/multiple-devices-task/io-setup"
                    component={IOSetUp}
                  />
                  <PrivateRoute
                    permissionName="single_io_set_up"
                    path="/io-setup/:device_id/:device_os_type"
                    component={IOSetUp}
                  />
                  <PrivateRoute
                    permissionName="multiple_rotation"
                    path="/multiple-devices-task/rotation"
                    component={Rotation}
                  />
                  <PrivateRoute
                    permissionName="device_detail_rotate"
                    path="/rotation/:device_id/:device_os_type"
                    component={Rotation}
                  />
                  {/* <PrivateRoute
                        permissionName="Device Monitoring"
                        path="/device-list/:group_id?"
                        component={DeviceList}
                      /> */}
                  <PrivateRoute
                    permissionName="DashBoard"
                    path="/dashboard"
                    component={Dashboard}
                  />
                  <PrivateRoute
                    permissionName="profile_template_view"
                    path="/profile-config/template"
                    component={ProfileTemplateList}
                  />
                  <PrivateRoute
                    permissionName="profile_template_view"
                    path="/profile-config/template-android"
                    component={ProfileCreateAndroidTemplate}
                  />
                  <PrivateRoute
                    permissionName="profile_template_create"
                    path="/profile-config/create-template-android"
                    component={ProfileCreateAndroidTemplate}
                  />
                  <PrivateRoute
                    permissionName="profile_template_edit"
                    path="/profile-config/edit-template-android/:id"
                    component={ProfileCreateAndroidTemplate}
                  />
                  <PrivateRoute
                    permissionName="profile_install_history_view"
                    path="/profile-config/install-history/:id"
                    component={ProfileCreateAndroidTemplate}
                  />
                  <PrivateRoute
                    permissionName="profile_template_view"
                    path="/profile-config/template-windows"
                    component={ProfileCreateWindowsTemplate}
                  />
                  <PrivateRoute
                    permissionName="profile_template_create"
                    path="/profile-config/create-template-windows"
                    component={ProfileCreateWindowsTemplate}
                  />
                  <PrivateRoute
                    permissionName="profile_template_edit"
                    path="/profile-config/edit-template-windows/:id"
                    component={ProfileCreateWindowsTemplate}
                  />
                  <PrivateRoute
                    permissionName="profile_install_history_view"
                    path="/profile-config/install-history-windows/:id"
                    component={ProfileCreateWindowsTemplate}
                  />
                  <PrivateRoute
                    permissionName="profile_install_history_view"
                    path="/profile-config/install-history"
                    component={InstallHistory}
                  />
                  <PrivateRoute
                    permissionName={[
                      "company_setting_view",
                      "device_naming_method_view"
                    ]}
                    path="/setting/company"
                    component={CompanySetting}
                  />
                  <PrivateRoute
                    permissionName="device_naming_method_view"
                    path="/setting/device-naming/list"
                    component={DeviceNaming}
                  />
                  <PrivateRoute
                    permissionName="device_naming_method_add"
                    path="/setting/device-naming/create"
                    component={CreateNaming}
                  />
                  <PrivateRoute
                    permissionName="device_naming_method_edit"
                    path="/setting/device-naming/edit/:id"
                    component={CreateNaming}
                  />
                  <PrivateRoute
                    path="/setting/device-naming/info/:id"
                    component={CreateNaming}
                  />
                  <PrivateRoute path="/announcement" component={Announcement} />
                  <PrivateRoute
                    path="/announcement-info/:id"
                    component={AnnouncementContent}
                  />
                  <PrivateRoute
                    path="/cms/template/full-screen/create"
                    component={CMSFullScreenTemplate}
                  />
                  <PrivateRoute
                    path="/cms/template/full-screen/:type/:id"
                    component={CMSFullScreenTemplate}
                  />
                  <PrivateRoute
                    path="/cms/template/pldm/create"
                    component={CMSPLDMTemplate}
                  />
                  <PrivateRoute
                    path="/cms/template/pldm/:type/:id"
                    component={CMSPLDMTemplate}
                  />
                  {/* <PrivateRoute path='/device-list' component={DeviceList}/>  */}
                  <Route path="/login" component={CASLogin} />
                  <Route path="/login-error" component={LoginError} />
                  <Route path="/no-permission" component={NoPermission} />
                  <PrivateRoute
                    permissionName="DashBoard"
                    path="/"
                    component={Dashboard}
                    exact
                  />
                  <PrivateRoute
                    path="/verify-email"
                    component={VerifyEmail}
                    showToolBar={false}
                    exact
                  />
                </Switch>
              </BrowserRouter>
            </SubmitBtnContext.Provider>
          </LanguageProvider>
        </GlobalProvider>
      </Auth>
    </Suspense>
  );
}

export default App;
